import React from 'react';
import ReadCookie from '../../../functions/readcookies';
import { Button } from 'semantic-ui-react';
import Loading from '../../loading';
import $ from "jquery";
import Server from '../../../functions/server';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Request extends React.Component {

  state = {
    sampleData: [],
    fullWidth: true,
    maxWidth: 'md',
    checkBox: []
  }


  getSampleRequest() {
    let context = this;
    let branch = this.getBranchs();
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    this.setState({ load: true, message: 'Getting sample Request!!!' })
    $.ajax({
      type: 'POST',
      data: { 'branch': branch, 'userId': userId },
      url: Server() + 'purchaserequest/getsamplerequest.php',
      success: function(data)
      {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          context.setState({ sampleData: data, viewSampleDialog: true })
        } catch (e) {

        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  close() {
    this.setState({ viewSampleDialog: false })
  }

  getBranchs() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      let branchState;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
        branchState = data[i].state;
      }
      return branchId;
    }
  }

  checkBox(id) {
    let checkBox = this.state.checkBox;
    if (checkBox.length > 0) {
      for (var i = 0; i < checkBox.length; i++) {
        if (checkBox[i].rid == id) {
          this.remove(id);
          return;
        }
      }
      this.add(id);
      return;
    }
    else {
      let sampleData = this.state.sampleData;
      sampleData.map((x) => {
        if (x.rid == id) {
          checkBox.push(x);
        }
      })
      this.setState({
        checkBox: checkBox
      });
      return;
    }
  }

  remove(id) {
    let checkBox = this.state.checkBox;
    let removed = [];
    checkBox.map((z) =>{
      if (z.rid != id) {
        removed.push(z);
      }
    })
    this.setState({
      checkBox: removed
    });
  }

  add(id) {
    let checkBox = this.state.checkBox;
    let sampleData = this.state.sampleData;
    sampleData.map((x) => {
      if (x.rid == id) {
        checkBox.push(x);
      }
    })

    this.setState({
      checkBox: checkBox
    });
  }

  handleChange = (name) => event => {
    this.checkBox(name);
  };

  addItems() {
    let data = this.props.parts;
    let items = this.state.checkBox;
    let y = 0;
    data.map((x) => {
      for (var i = 0; i < items.length; i++) {
        if (x.partno == items[i].partno) {
          items[i].id = y;
          items[i].partno = x.partno;
          items[i].brand = items[i].brand_id;
          items[i].partname = x.spare_name;
          items[i].brand_name =  items[i].brand_name;
          items[i].mrp =  x.mrp;
          items[i].dnp =  x.dnp;
          items[i].order_by =  13;
          items[i].part_id = x.part_id;
          items[i].tax = x.tax;
          items[i].partcode = x.part_id;
          items[i].purchaser = this.props.selectedPurchaser;
          items[i].date = this.props.date;
          items[i].branch = this.props.branch;
          items[i].order_by = this.props.orderBy;
          items[i].dropdownvalue = x.part_alias+'->'+x.spare_name+'->'+x.part_id;
          y++;
        }
      }
    });
    this.props.addItemFromSample(items);
    this.close();
  }

  render() {
    let i = 0;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <div  style={{display: this.props.temprequest}}>
        <Button primary fluid
          onClick={this.getSampleRequest.bind(this)}>
          Temp Purchase Req
        </Button>
        </div>

        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
            open={this.state.viewSampleDialog} onClose={ () => { this.setState({ open: false }) }}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Sample Request</DialogTitle>
            <DialogContent>
              <table id="table" width="100%">
                <tr>
                  <th><center>Sino</center></th>
                  <th><center>Executive</center></th>
                  <th><center>Spare</center></th>
                  <th><center>Brand</center></th>
                  <th><center>Stocks</center></th>
                  <th><center>Date</center></th>
                  <th style={{ display: this.props.display }}><center>Select</center></th>
                </tr>
                { this.state.sampleData.map((x) => {
                    i++;
                    return (
                      <tr>
                        <td><center>{i}</center></td>
                        <td><center>{x.executive_id+"->"+x.executive_name}</center></td>
                        <td><center>{x.partno+"->"+x.spare_name}</center></td>
                        <td><center>{x.brand_name}</center></td>
                        <td><center>{x.stock}</center></td>
                        <td><center>{x.timestamp}</center></td>
                        <td style={{ display: this.props.display }}>
                          <center>
                          <Checkbox id={x.rid} onChange={this.handleChange(x.rid)} color="primary" />
                          </center>
                        </td>
                      </tr>
                    )
                  })
                }
              </table>
            </DialogContent>
            <DialogActions>
              <Button style={{ display: this.props.display }} onClick={this.addItems.bind(this)}>Add Items</Button>
              <Button onClick={this.close.bind(this)}>Close</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Request;
